import React, { useEffect, useRef, useState } from "react";
import { getData, postData } from "../../services/api.service";
import {
  swalAlertDanger,
  swalAlertSuccess,
  swalConfirmationAlert,
} from "../../components/common/Alerts";
import TableDataRender from "../../components/common/TableDataRender";
import { FaBullhorn } from "react-icons/fa";
import ModalWindow from "../../components/ModalWindow";
import FormClientsDifusion from "./components/forms/FormClientsDifusion";
import BackButton from "../../components/common/BackButton";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";

const AdminClients = () => {
  const navigate = useNavigate();
  const { id_branch } = useParams();
  const dataUser = useSelector((state) => state.user.dataUser);
  const tableRef = useRef();
  const [clients, setClients] = useState([]);

  const [showModalDifusion, setShowModalDifusion] = useState(false);

  const fetchData = async () => {
    if (dataUser === null || dataUser.role_id !== 1) {
      navigate("/");
    }

    const res = await getData("/api/admin/get_historical_clients");

    if (res.status === 200) {
      setClients(res.data.clients);
    } else {
      console.error("Error al obtener los clientes:", res.data.msg);
      swalAlertDanger("Error", "No se pudieron cargar los clientes.", () => {});
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  const handleSendDifusion = async (difusion) => {
    const data = {
      subject: difusion.subject,
      message: difusion.message,
    };
    swalConfirmationAlert(
      "Confirmación",
      "¿Estás seguro de enviar la difusión a todos los clientes? Esta acción puede demorar algunos segundos",
      async () => {
        const res = await postData("/api/admin/send_clients_difusion", data);

        if (res.status === 200) {
          swalAlertSuccess(
            "Éxito",
            "Difusión enviada exitosamente a todos los clientes.",
            () => {
              setShowModalDifusion(false);
              fetchData();
            }
          );
        } else {
          console.error("Error al enviar la difusión:", res.data.msg);
          swalAlertDanger("Error", res.data.msg, () => {});
        }
      }
    );
  };

  const columnMapping = {
    APELLIDO: { key: "last_name", align: "center" },
    NOMBRE: { key: "first_name", align: "center" },
    EMAIL: { key: "email", align: "center" },
    TELÉFONO: { key: "phone_number", align: "center" },
  };

  return (
    <div className="container mt-5 text-white">
      <div>
        <button
          className="btn btn-outline-light mb-3"
          onClick={() => navigate(`/home/admin_panel/${id_branch}`)}
        >
          ← Volver al Panel
        </button>
      </div>
      <h3 className="text-center">Panel de Clientes</h3>
      <p className="text-center">
        Histórico de clientes y difusión de promociones.
      </p>
      <div className="bg-white shadow p-3 mt-5">
        <div className="col-4">
          <button
            className="btn btn-primary mb-3"
            onClick={() => setShowModalDifusion(true)}
          >
            <FaBullhorn /> ENVIAR DIFUSION
          </button>
        </div>
        <TableDataRender
          data={clients}
          columnMapping={columnMapping}
          tableRef={tableRef}
          scroll={true}
        />
      </div>
      <ModalWindow
        title={"Enviar difusión a clientes"}
        body={<FormClientsDifusion handleSendDifusion={handleSendDifusion} />}
        modalOpen={showModalDifusion}
        setModalOpen={setShowModalDifusion}
        footer={
          "Puedes enviar promociones y novedades a todos tus clientes con tan solo un par de clics."
        }
      />
    </div>
  );
};

export default AdminClients;
